import React from 'react'
import styled from 'styled-components'
import { MenuLink, icons, size } from './platform'

const LogoBlock = styled(MenuLink)`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 0 20px !important;
  @media (max-width: ${size.md}) {
    margin-right: 17px;
  }

  @media (max-width: ${size.sm}) {
    margin-right: 0;
  }

  @media (max-width: ${size.xs}) {
    z-index: 7;
    width: 48px;
    min-width: 48px;
  }
`

export const MenuLogo = () => (
  <LogoBlock href="/">
    <icons.LogoImage />
  </LogoBlock>
)
